import React, { useState, useRef, useEffect } from "react";
import { CSSTransition } from "react-transition-group";

export const FAQItem = ({ question, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    // Actualiza la altura del contenido cuando está abierto
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0); // Cierra el panel
    }
  }, [isOpen]);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={toggleAnswer}>
        {question}
      </div>
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames="faq-answer"
        unmountOnExit
        nodeRef={contentRef}
      >
        <div
          className="faq-answer"
          ref={contentRef}
          style={{
            height: `${height}px`, // Aplica la altura calculada
            overflow: "hidden",
          }}
        >
          <div className="faq-answer-content">{children}</div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default FAQItem;
